/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */
import type { QueryFunction, QueryKey, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { LicensedProduct, ProblemDetails, UserAccessDetails, UserClaims } from '../../model';
import type { ErrorType } from '../../utils/UseCustomInstance';
import { useCustomInstance } from '../../utils/UseCustomInstance';

export const useGetClaimsForCurrentUserHook = () => {
    const getClaimsForCurrentUser = useCustomInstance<UserClaims>();

    return (signal?: AbortSignal) => {
        return getClaimsForCurrentUser({ url: `/User/GetClaimsForCurrentUser`, method: 'get', signal });
    };
};

export const getGetClaimsForCurrentUserQueryKey = () => [`/User/GetClaimsForCurrentUser`] as const;

export const useGetClaimsForCurrentUserQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetClaimsForCurrentUserHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClaimsForCurrentUserHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClaimsForCurrentUserHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetClaimsForCurrentUserQueryKey();

    const getClaimsForCurrentUser = useGetClaimsForCurrentUserHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetClaimsForCurrentUserHook>>>> = ({ signal }) =>
        getClaimsForCurrentUser(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetClaimsForCurrentUserQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetClaimsForCurrentUserHook>>>>;
export type GetClaimsForCurrentUserQueryError = ErrorType<ProblemDetails>;

export const useGetClaimsForCurrentUser = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetClaimsForCurrentUserHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetClaimsForCurrentUserHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetClaimsForCurrentUserQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetUserAccessDetailsHook = () => {
    const getUserAccessDetails = useCustomInstance<UserAccessDetails>();

    return (signal?: AbortSignal) => {
        return getUserAccessDetails({ url: `/User/GetUserAccessDetails`, method: 'get', signal });
    };
};

export const getGetUserAccessDetailsQueryKey = () => [`/User/GetUserAccessDetails`] as const;

export const useGetUserAccessDetailsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserAccessDetailsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserAccessDetailsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserAccessDetailsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserAccessDetailsQueryKey();

    const getUserAccessDetails = useGetUserAccessDetailsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserAccessDetailsHook>>>> = ({ signal }) =>
        getUserAccessDetails(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetUserAccessDetailsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserAccessDetailsHook>>>>;
export type GetUserAccessDetailsQueryError = ErrorType<ProblemDetails>;

export const useGetUserAccessDetails = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetUserAccessDetailsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserAccessDetailsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetUserAccessDetailsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetLicensedProductsHook = () => {
    const getLicensedProducts = useCustomInstance<LicensedProduct[]>();

    return (signal?: AbortSignal) => {
        return getLicensedProducts({ url: `/User/GetLicensedProducts`, method: 'get', signal });
    };
};

export const getGetLicensedProductsQueryKey = () => [`/User/GetLicensedProducts`] as const;

export const useGetLicensedProductsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetLicensedProductsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLicensedProductsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLicensedProductsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetLicensedProductsQueryKey();

    const getLicensedProducts = useGetLicensedProductsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetLicensedProductsHook>>>> = ({ signal }) =>
        getLicensedProducts(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetLicensedProductsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetLicensedProductsHook>>>>;
export type GetLicensedProductsQueryError = ErrorType<ProblemDetails>;

export const useGetLicensedProducts = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetLicensedProductsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetLicensedProductsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetLicensedProductsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};
